import { render, staticRenderFns } from "./PoolUserInvitations.vue?vue&type=template&id=3dcf7081&scoped=true&"
import script from "./PoolUserInvitations.vue?vue&type=script&lang=js&"
export * from "./PoolUserInvitations.vue?vue&type=script&lang=js&"
import style0 from "./PoolUserInvitations.vue?vue&type=style&index=0&id=3dcf7081&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcf7081",
  null
  
)

export default component.exports